import React, {useEffect, useState} from "react";
import Deployment from "../../components/deployment/deployment";
import {useParams} from "react-router-dom";
import {axiosInstance} from "../../../../config/http";
import axios from 'axios';
import {get} from "lodash";
import {Button} from "../../../../common/styled";
import {EditDeploymentWrapper} from "../../styles/styled";
import {
  overlayStyle,
  dialogBoxStyle,
  buttonsContainerStyle,
  confirmButtonStyle
} from "../../../../common/styled";
import {toast} from "react-toastify";
import {isValidJsonString} from "../../../../common/utils";
import {useNavigate} from "react-router-dom";

const normalizeDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return isNaN(d) ? '' : d.toISOString().split('T')[0]; // Ensures YYYY-MM-DD
};

export default function EditDeployment() {
  const navigate = useNavigate()
  const [deployment, setDeployment] = useState({})

  let {name} = useParams();
  useEffect(() => {
    axiosInstance.get('/deployment?deployment_name=' + name).then(response => {
      console.log(response)
      let deployment = get(response, 'data', [])
      let jsonScript = get(deployment, 'script', '')
      if (jsonScript) {
        jsonScript = JSON.parse(jsonScript)
        jsonScript = JSON.stringify(jsonScript, null, 4)
        deployment['script'] = jsonScript
      }

      deployment['start_date'] = normalizeDate(deployment['start_date']);
      deployment['end_date'] = normalizeDate(deployment['end_date']);

      setDeployment(deployment)
    }).catch(error => {
      console.log(error)
    })
  }, [name])

  const updateDeployment = () => {
    if (!isValidJsonString(deployment.script)) {
      toast.error("Syntax error in the script!")
      return
    }
    console.log("updating deployment", deployment)
    axiosInstance.put('/deployment', deployment).then(response => {
      if (get(response, 'data.msg', '') === 'success') {
        toast.success("Saved successfully!")
      } else if (get(response, 'data.error')) {
        toast.error("Failed! " + get(response, 'data.error'))
      } else {
        toast.error("Failed! Please contact the dev team.")
      }
    }).catch(error => {
      console.error(error)
      toast.error("Failed! Please contact the dev team.")
    })
  }

  function createCustomConfirmDialog(message, callback) {
    const overlay = document.createElement('div');
    overlay.style.cssText = overlayStyle.styles;
  
    const dialogBox = document.createElement('div');
    dialogBox.style.cssText = dialogBoxStyle.styles;
  
    const messageParagraph = document.createElement('p');
    messageParagraph.textContent = message;
    dialogBox.appendChild(messageParagraph);
  
    const buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = buttonsContainerStyle.styles;
  
    const yesButton = document.createElement('button');
    yesButton.textContent = 'Yes';
    yesButton.style.cssText = confirmButtonStyle.styles;
    yesButton.addEventListener('click', () => {
      document.body.removeChild(overlay);
      callback(true);
    });
  
    const noButton = document.createElement('button');
    noButton.textContent = 'No';
    noButton.style.cssText = confirmButtonStyle.styles;
    noButton.addEventListener('click', () => {
      document.body.removeChild(overlay);
      callback(false);
    });
  
    buttonsContainer.appendChild(yesButton);
    buttonsContainer.appendChild(noButton);
    dialogBox.appendChild(buttonsContainer);
    overlay.appendChild(dialogBox);
    document.body.appendChild(overlay);
  }
  
  const deleteDeployment = () => {
    if (!isValidJsonString(deployment.script)) {
      toast.error("Syntax error in the script!");
      return;
    }
    // Confirmation before deleting the deployment
    createCustomConfirmDialog("Are you sure you want to delete this deployment? This action cannot be undone.", (confirmed) => {
      if (confirmed) {
        axiosInstance.delete('/deployment', { params: { deployment_name: deployment["deployment_name"] } }).then(response => {
          if (get(response, 'data.msg', '') === 'success') {
            toast.success("Deleted successfully!");
            navigate('/');
          } else if (get(response, 'data.error')) {
            toast.error("Failed! " + get(response, 'data.error'));
          } else {
            toast.error("Failed! Please contact the dev team.");
          }
        }).catch(error => {
          console.error(error);
          toast.error("Failed! Please contact the dev team.");
        });
      }
    });
  }

  const exportDeployment = () => {
    console.log("exporting deployment", deployment)
    axiosInstance({
        url: '/download_csv',
        method: 'GET',
        responseType: 'blob',
        params: {deployment_name: deployment["deployment_name"]},
    }).then(response => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', deployment["deployment_name"] + '.csv');

        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        toast.success("Exported successfully!")

    }).catch(error => {
      console.error(error)
      toast.error("Failed! Please contact the dev team about the following: " + error)
    });
  }


  return <EditDeploymentWrapper>
    {deployment && <Deployment isEdit deployment={deployment} setDeployment={setDeployment}/>}
    <Button onClick={updateDeployment}>Save changes</Button>
    <Button onClick={deleteDeployment}>Delete deployment</Button>
    <Button onClick={exportDeployment}>Export deployment results as CSV</Button>
  </EditDeploymentWrapper>
}
